import { render, staticRenderFns } from "./AvailablePlans.vue?vue&type=template&id=28869d95&"
import script from "./AvailablePlans.vue?vue&type=script&lang=js&"
export * from "./AvailablePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports